
export const pick = (obj, props) => {
  return props.reduce((result, prop) => {
    result[prop] = obj[prop]
    return result
  }, {})
}

export const filterMissing = (obj) => {
  return Object.keys(obj).reduce((result, prop) => {
    if (obj[prop]) {
      result[prop] = obj[prop]
    }
    return result
  }, {})
}



// WEBPACK FOOTER //
// ./client/src/util/objects.js